// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card {\n  margin: 0;\n  position: relative;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 26px 20px 30px 26px;\n  border: 2px solid white;\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
